import React, { useEffect, useRef, useState } from "react";
import { Html5Qrcode } from "html5-qrcode";
import { Camera, Keyboard, X } from "lucide-react";

export const QRScanner = ({ onDecode, onManual }) => {
  const containerRef = useRef(null);
  const scannerRef = useRef(null);
  const [running, setRunning] = useState(false);
  const [err, setErr] = useState("");

  const start = async () => {
    setErr("");
    try {
      const html5 = new Html5Qrcode("qr-reader");
      scannerRef.current = html5;
      await html5.start(
        { facingMode: "environment" },
        { fps: 10, qrbox: 240 },
        (text) => {
          onDecode && onDecode(text);
          stop();
        },
        () => {}
      );
      setRunning(true);
    } catch (e) {
      setErr("Camera not available. Use manual entry below.");
    }
  };

  const stop = async () => {
    try {
      if (scannerRef.current && scannerRef.current.isScanning) {
        await scannerRef.current.stop();
        await scannerRef.current.clear();
      }
    } catch (e) {}
    setRunning(false);
  };

  useEffect(() => {
    return () => {
      stop();
    };
    // eslint-disable-next-line
  }, []);

  return (
    <div className="w-full" data-testid="qr-scanner">
      <div className="scanner-box mx-auto">
        <div className="scanner-corner tl" />
        <div className="scanner-corner tr" />
        <div className="scanner-corner bl" />
        <div className="scanner-corner br" />
        <div id="qr-reader" ref={containerRef} className="w-full h-full" />
        {!running && (
          <div className="absolute inset-0 flex flex-col items-center justify-center gap-3 p-6 text-center">
            <Camera size={32} className="text-[#E6B455]" />
            <p className="text-sm text-[#F7E6B4]/70">
              Point camera at merchant's QR code
            </p>
            <button
              onClick={start}
              className="btn-gold px-5 py-2.5 rounded-full text-sm"
              data-testid="scanner-start-btn"
            >
              Start Camera
            </button>
          </div>
        )}
      </div>
      {err && (
        <p className="text-sm text-amber-400 mt-3 text-center" data-testid="scanner-error">
          {err}
        </p>
      )}
      <div className="mt-6 flex flex-col items-center gap-2">
        {running && (
          <button
            onClick={stop}
            className="flex items-center gap-2 text-sm text-[#F7E6B4]/70 hover:text-[#F7E6B4]"
            data-testid="scanner-stop-btn"
          >
            <X size={14} /> Stop Camera
          </button>
        )}
        <button
          onClick={() => {
            stop();
            onManual && onManual();
          }}
          className="flex items-center gap-2 text-sm text-[#E6B455] hover:underline mt-1"
          data-testid="scanner-manual-btn"
        >
          <Keyboard size={14} /> Enter code manually
        </button>
      </div>
    </div>
  );
};
